import React, { useState } from 'react';
import { Button, FormGroup } from 'react-bootstrap';
import ReactCommonmark from 'react-commonmark';
import globeIcon from 'v2/icons/globe.svg';
import { DataProviderEntity } from 'v2/models';
import { getAbsoluteLink } from 'v2/utils/dataProviderUtils';

interface ProviderProfileProps {
  dataProvider: DataProviderEntity;
  hideIdentity: boolean;
}

const ProviderProfile = ({
  dataProvider,
  hideIdentity,
}: ProviderProfileProps) => {
  const [isExpanded, setIsExpanded] = useState(false);
  return (
    <FormGroup className="mt-5">
      <h1>Your Profile</h1>
      <p className="text-light8">
        The buyer will also be able to see your profile.
      </p>
      <Button
        variant="link"
        className="p-0 mb-3"
        onClick={() => setIsExpanded(!isExpanded)}
      >
        {isExpanded ? 'Collapse Your Profile' : 'Expand Your Profile'}
      </Button>
      {isExpanded ? (
        <div className="bg-light px-4 py-3 text-light4">
          {dataProvider.external_links.length ? (
            <div className="py-4">
              <a
                href={getAbsoluteLink(dataProvider.external_links[0].url)}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={globeIcon} className="mr-2" alt="websiteIcon"></img>
                Visit Website
              </a>
            </div>
          ) : null}

          <ReactCommonmark
            source={
              hideIdentity
                ? dataProvider.vague_description
                : dataProvider.long_description
            }
            softBreak="br"
          />
        </div>
      ) : null}
    </FormGroup>
  );
};

export default ProviderProfile;
